export const TOKEN_EXPIRY_THRESHOLD = 100

export const DIGITIZE_ORDER_TYPE = "DIGITIZE"

export const ALL_ORDER_TYPE = "ALL_ORDERS"
export const PRESORTED_ORDER_TYPE = "PRESORTED_ORDERS"
export const STRIPS_ORDER_TYPE = "STRIPS_ORDERS"

export const ALL_QUOTATIONS_TYPE = "ALL_QUOTATIONS"
export const PRESORTED_QUOTATIONS_TYPE = "PRESORTED_QUOTATIONS"
export const STRIPS_QUOTATIONS_TYPE = "STRIPS_QUOTATIONS"

export const ROLES = {
    "SUPPORT": "SUPPORT",
    "PHARMACIST": "PHARMACIST",
    "ADMIN": "ADMIN",
    "MARKETING": "MARKETING",
    "USER": "USER",
    "SUPER_ADMIN": "SUPER_ADMIN",
    "SUPER_SUPPORT": "SUPER_SUPPORT",
    "KAM": "KAM",
    // SALES / SUPER_SALES are retired: the Sales Console runs on SUPPORT / SUPER_SUPPORT
    // (see SALES_ROLES in src/v2/constants/roles.js) and no route grants either of them.
    // Kept defined only so users still carrying them load until they are reassigned.
    "SALES": "SALES",
    "DOCTOR": "DOCTOR",
    "PARTNER": "PARTNER",
    // Finance Console (/v2/finance). SUPER_FINANCE is the role the console runs on;
    // FINANCE is reserved and currently grants nothing -- see pillup-api
    // classes/User/Constants.js and tests/unit/routes/financeRoleAllowlists.test.js.
    "FINANCE": "FINANCE",
    "SUPER_FINANCE": "SUPER_FINANCE",
    // Logistics Console (/v2/logistics). Same shape as the finance pair: SUPER_LOGISTICS
    // runs the console, LOGISTICS is reserved and grants nothing.
    "LOGISTICS": "LOGISTICS",
    "SUPER_LOGISTICS": "SUPER_LOGISTICS",
    // Inventory Console (/v2/pharmacy/inventory + /procurement). Same shape again:
    // SUPER_INVENTORY runs it, INVENTORY is reserved and grants nothing.
    "INVENTORY": "INVENTORY",
    "SUPER_INVENTORY": "SUPER_INVENTORY",
    "OPS_SUPPORT": "OPS_SUPPORT",
    "SUPER_OPS_SUPPORT": "SUPER_OPS_SUPPORT",
    "SUPER_PHARMACIST": "SUPER_PHARMACIST",
    "SUPER_SALES": "SUPER_SALES",



}

// Drives the role dropdown in the Create User modal
// (src/components/modal-forms/create-user/index.jsx:183).
//
// This mirrors pillup-api's ROLE_CREATE_HEIRARCHY (classes/User/Constants.js) but is a
// SEPARATE list. SALES and SUPER_SALES are deliberately NOT offered: they are retired and
// grant no access, so a user created with one would open nothing.
// A DUPLICATE of pillup-api classes/User/Constants.js ROLE_CREATE_HEIRARCHY. It decides
// only what the Create User form OFFERS -- the API re-validates every choice in
// validateCreateRoles, so it can never grant more than the server allows. It CAN silently
// grant less, which is the failure that keeps happening: a merge dropped SALES and the four
// console tier roles from the lists below while leaving their keys intact, and the form
// quietly stopped offering them. The tests in
// src/v2/constants/__tests__/consoles.test.js exist to catch exactly that.
export const ROLE_CREATE_HEIRARCHY = {
    [ROLES.SUPER_ADMIN]: [ROLES.ADMIN, ROLES.PARTNER, ROLES.USER, ROLES.SUPPORT, ROLES.SUPER_SUPPORT, ROLES.KAM, ROLES.PHARMACIST, ROLES.DOCTOR, ROLES.MARKETING, ROLES.OPS_SUPPORT, ROLES.SUPER_OPS_SUPPORT, ROLES.SUPER_PHARMACIST, ROLES.FINANCE, ROLES.SUPER_FINANCE, ROLES.LOGISTICS, ROLES.SUPER_LOGISTICS, ROLES.INVENTORY, ROLES.SUPER_INVENTORY],
    [ROLES.ADMIN]: [ROLES.USER, ROLES.SUPPORT, ROLES.SUPER_SUPPORT, ROLES.KAM, ROLES.PHARMACIST, ROLES.DOCTOR, ROLES.MARKETING, ROLES.OPS_SUPPORT, ROLES.SUPER_OPS_SUPPORT, ROLES.SUPER_PHARMACIST, ROLES.FINANCE, ROLES.SUPER_FINANCE, ROLES.LOGISTICS, ROLES.SUPER_LOGISTICS, ROLES.INVENTORY, ROLES.SUPER_INVENTORY],
    [ROLES.SUPER_SUPPORT]: [ROLES.SUPPORT, ROLES.USER],
    [ROLES.SUPPORT]: [ROLES.USER],
    [ROLES.KAM]: [],
    [ROLES.PHARMACIST]: [ROLES.USER],
    [ROLES.DOCTOR]: [],
    [ROLES.USER]: [],
    // PARTNER and MARKETING are assignable but had no key of their own, so the Create User
    // form threw for anyone holding them -- 2 active MARKETING users. The `|| []` guard in
    // the form covers it; these keys make the map itself consistent.
    [ROLES.PARTNER]: [],
    [ROLES.MARKETING]: [],
    [ROLES.SALES]: [],
    // Neither finance role manages users -- matches the server.
    [ROLES.FINANCE]: [],
    [ROLES.SUPER_FINANCE]: [],
    [ROLES.LOGISTICS]: [],
    [ROLES.SUPER_LOGISTICS]: [],
    [ROLES.INVENTORY]: [],
    [ROLES.SUPER_INVENTORY]: [],
    [ROLES.OPS_SUPPORT]: [],
    [ROLES.SUPER_OPS_SUPPORT]: [],
    [ROLES.SUPER_PHARMACIST]: [],
    [ROLES.SUPER_SALES]: []
};

export const TENANTS = {
    "dev-pillengine.pillup.com": "2eea1b63-6b1a-4b56-811a-df849d953c6d",
    "pillengine.pillup.com": "2eea1b63-6b1a-4b56-811a-df849d953c6d",

    "dev-pillengine.eazydose.in": "efdb62cf-5d22-4752-9c4f-faae13da1322",
    "pillengine.eazydose.in": "efdb62cf-5d22-4752-9c4f-faae13da1322"
};

export const TENANT_COMPANY_MAP = {
    "PILLUP": "2eea1b63-6b1a-4b56-811a-df849d953c6d",
    "EAZY": "efdb62cf-5d22-4752-9c4f-faae13da1322"
}

// Selecting this status requires a cancellation reason before the change is saved.
export const ORDER_CANCELLED = 'ORDER_CANCELLED';

export const PRESORTED = 'PRESORTED';
export const STRIPS = 'STRIPS';

export const CHRONICITY_MAP = {
    HYPERTENSION: "Hypertension",
    DIABETES: "Diabetes",
    RESPIRATORY: "Respiratory/Lung",
    CARDIO: "Cardio/Heart",
    ORTHO: "Ortho/Arthritis",
    NEURO: "Neuro",
    NEPHRO: "Nephro/Kidney",
    CANCER: "Cancer",
    MULTIVITAMIN_WELLNESS: "Multi-Vitamin/Wellness",
    THYROID: "Thyroid",
    GASTRO: "Gastro",
    SEIZURE: "Seizure",
    PANCREATIC: "Pancreatic",
    STEROID: "Steroid",
    IMMUNOSUPPRESSANTS: "Immunosuppressants",
    HYPOTENSION: "Hypotension",
    OTHER: "Other"
}

// Expiries are in days
export const COOKIE_EXPIRY_FOR_USER = 365;
export const COOKIE_EXPIRY_FOR_ROLES = 365;
export const COOKIE_EXPIRY_FOR_REFRESH_TOKEN = 365;
export const COOKIE_EXPIRY_FOR_TOKEN = 365;
export const COOKIE_EXPIRY_FOR_TOKEN_EXPIRES_AT = 365;
